import axios from 'axios';
import Swal from 'sweetalert2';
import { loadingService } from './loading.service';
import getApiBaseUrl from './getserver.service';
import { adminTokenService } from './admin.token.service';
import { tokenService } from './token.service';

const api = axios.create({
  baseURL: getApiBaseUrl(),
});

let isSessionExpiredAlertOpen = false;

api.interceptors.request.use(
  (config) => {
    if (!config.headers['X-Skip-Loading']) {
      loadingService.show();
    }
    return config;
  },
  (error) => {
    loadingService.hide();
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    if (!response.config.headers['X-Skip-Loading']) {
      loadingService.hide();
    }
    return response;
  },
  (error) => {
    if (!error.config?.headers['X-Skip-Loading']) {
      loadingService.hide();
    }

    const statusCode = error.response?.status || error.response?.data?.statusCode;
    const requestUrl = error.config?.url || '';

    // No interceptar endpoints de login/autenticación para permitir que la vista muestre errores de credenciales
    const isLoginEndpoint =
      requestUrl.includes('/admin/login') ||
      requestUrl.includes('/login') ||
      requestUrl.includes('/auth/login') ||
      requestUrl.includes('/customer-login') ||
      requestUrl.includes('/customer-signin') ||
      requestUrl.includes('/customer-pickup-signin') ||
      requestUrl.includes('/customer-exist') ||
      requestUrl.includes('/signin') ||
      requestUrl.includes('/token') ||
      requestUrl.includes('/verify-code') ||
      requestUrl.includes('/recovery');

    if (statusCode === 401 && !isLoginEndpoint) {
      const isAdminRoute = window.location.pathname.startsWith('/admin');

      if (isAdminRoute) {
        adminTokenService.removeAdminToken();
        if (!isSessionExpiredAlertOpen && window.location.pathname !== '/admin/login') {
          isSessionExpiredAlertOpen = true;
          Swal.fire({
            icon: 'warning',
            title: 'Sesión Expirada',
            text: 'Tu sesión de administrador ha caducado. Por favor, inicia sesión nuevamente para continuar.',
            confirmButtonText: 'Iniciar Sesión',
            confirmButtonColor: '#ffc107',
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then(() => {
            isSessionExpiredAlertOpen = false;
            window.location.href = '/admin/login';
          });
        }
      } else {
        tokenService.removeToken();
        if (!isSessionExpiredAlertOpen && window.location.pathname !== '/login') {
          isSessionExpiredAlertOpen = true;
          Swal.fire({
            icon: 'warning',
            title: 'Sesión Expirada',
            text: 'Tu sesión ha caducado. Por favor, inicia sesión nuevamente para continuar.',
            confirmButtonText: 'Iniciar Sesión',
            confirmButtonColor: '#e84d30',
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then(() => {
            isSessionExpiredAlertOpen = false;
            window.location.href = '/login';
          });
        }
      }
    }

    return Promise.reject(error);
  }
);

export default api;

